module.exports = __webpack_public_path__ + "img/vu-logo-with-words.ac2cb230.png";